import React, { useEffect, useState } from "react";
import "./InstallPrompt.css";

const InstallPrompt = () => {
  const [prompt, setPrompt] = useState(null);
  const [showIosHelp, setShowIosHelp] = useState(false);
  const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
  const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  useEffect(() => {
    const savePrompt = (event) => { event.preventDefault(); setPrompt(event); };
    const installed = () => { setPrompt(null); setShowIosHelp(false); };
    window.addEventListener("beforeinstallprompt", savePrompt);
    window.addEventListener("appinstalled", installed);
    return () => {
      window.removeEventListener("beforeinstallprompt", savePrompt);
      window.removeEventListener("appinstalled", installed);
    };
  }, []);

  if (standalone || (!prompt && !isIos)) return null;

  const install = async () => {
    if (prompt) {
      await prompt.prompt();
      await prompt.userChoice;
      setPrompt(null);
    } else {
      setShowIosHelp((value) => !value);
    }
  };

  return (
    <aside className="install-dock" aria-label="COOLDOC app install">
      {showIosHelp && <div className="ios-install-help">Safari의 공유 버튼을 누른 뒤 <strong>홈 화면에 추가</strong>를 선택하세요.</div>}
      <button type="button" onClick={install}><span aria-hidden="true">↓</span> 앱 설치</button>
    </aside>
  );
};

export default InstallPrompt;
